import { useEffect } from 'react'
import Shepherd from 'shepherd.js'
import 'shepherd.js/dist/css/shepherd.css'
import './style.css'
import { useDispatch } from 'react-redux'
import { setInsuranceDetailsTour, setPolicyTileCardTour } from 'src/actions'

const PolicyTileCardTour = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    let tour = new Shepherd.Tour({
      useModalOverlay: true,
      disableInteraction: true,
      exitOnEsc: false,
      defaultStepOptions: {
        attachTo: {
          element: '.RiskScoreTourStep1',
          on: 'bottom',
        },
        scrollTo: true,
      },
    })

    tour?.addStep({
      text: '<div id="viewPolicyDetails">Here you can find different types of group of Policies<b>Click here to <b>View All the policies of this group<b></div>',
      scrollTo: {
        behavior: 'smooth',
        block: 'center',
      },
      attachTo: {
        element: '#policyTileCard',
        on: 'right',
      },
    })

    const handleTourComplete = () => {
      dispatch(setPolicyTileCardTour(false))
      dispatch(setInsuranceDetailsTour(true))
    }

    tour?.on('complete', handleTourComplete)

    tour?.start()

    return () => {
      tour?.complete(() => {})
    }
  }, [dispatch])

  return null
}

export default PolicyTileCardTour
